import { render, staticRenderFns } from "./PreTreatmentAckCard.vue?vue&type=template&id=44b8f95a"
import script from "./PreTreatmentAckCard.vue?vue&type=script&lang=js"
export * from "./PreTreatmentAckCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports